module.exports = __webpack_public_path__ + "img/imgsx1.34f1e6a7.jpg";